import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {JobsOffer} from '../models/jobs-offer';
import 'rxjs/add/operator/map';
import {JobsOffersApplicant} from '../models/jobs-offers-applicant'
import { Subject } from 'rxjs/Subject';

@Injectable()
export class JobOffersService {

  private jobUrl: string = `${ environment.apiRoot }/job/`;
  private jobFreelancerUrl: string = `${ environment.apiRoot }/job-freelancer/`;
  private jobAddFreelancerUrl: string = `${ environment.apiRoot }/freelancer-job/`;
  private jobStatusUrl: string = `${ environment.apiRoot }/job/`;
  private jobContractUrl: string = `${ environment.apiRoot }/contract-job/`;
  private applicantUrl: string = `${ environment.apiRoot }/applicant/`;
  private qaUrl: string = `${ environment.apiRoot }/q-a/`;
  private levelProfileUrl: string = `${ environment.apiRoot }/level-profile/`;
  private reqNoFreelancer: string = `${ environment.apiRoot }/req-no-freelancer/`;
  private posCompanyUrl: string = `${ environment.apiRoot }/contract-job/`;

  constructor(private http: HttpAuth) { }

  public _subject = new Subject<object>();
  public event = this._subject.asObservable();

  public publish (data: JobsOffer) {
    this._subject.next(data);
  }

  public getOffers (query?: string, venue?: string, status?: any[], page?: number, pagecount?: number, premium?:number, query_skill?: string, query_edu?:string, query_exp?:string, myOffer?:boolean, freelancer?:number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (query) {
        params.set('query', query);
    }

    if (query_skill) {
        params.set('query_skill', query_skill);
    }
    if (query_edu) {
        params.set('query_edu', query_edu);
    }
    if (query_exp) {
        params.set('query', query_exp);
    }

    if (venue) {
        params.set('venue_id', venue);
    }
    if (status) {
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    if (page) {
      params.append('page', String(page));
    }

    if (pagecount) {
      params.append('pagecount', String(pagecount));
    }

    if (premium !== undefined) {
      params.append('premium', String(premium));
    }

    if (freelancer !== undefined) {
      params.append('freelancer', String(freelancer));
    }


    if (myOffer !== undefined) {
      if (myOffer) {
        params.append('myjobs', String(1));
      } else {
        params.append('myjobs', String(0));
      }
    }

    params.set('summary', '1');

    const options = new RequestOptions({search: params});

    return this.http.get(this.jobStatusUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOfferContracts(query?: string, page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (query) {
        params.set('query', query);
    }

    if (page) {
      params.append('page', String(page));
    }

    if (pagecount) {
      params.append('pagecount', String(pagecount));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.jobContractUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReqNoFreelancer(filter: string, filter2: string, filter3: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('withfreelancer', filter);
    params.set('withjob', filter2);
    params.set('assigned', filter3);
    const options = new RequestOptions({search: params});

    return this.http.get(this.reqNoFreelancer, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersFreelancer(query?: string, venue?: string, status?: any[], page?: number, pagecount?: number, query_skill?: string, query_edu?:string, query_exp?:string, myOffer?:boolean): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();

    if(query){
        params.set('query',query);
    }

    if(query_skill){
        params.set('query_skill',query_skill);
    }
    if(query_edu){
        params.set('query_edu',query_edu);
    }
    if(query_exp){
        params.set('query',query_exp);
    }

    if(venue){
        params.set('venue_id',venue);
    }
    // if(city){
    //     params.set('city',city);
    // }
    if(status){
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    if(page) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    params.append('premium', String(1));

    if(myOffer != undefined) {
      if (myOffer) {
        params.append('myjobs', String(1));
      } else {
        params.append('myjobs', String(0));
      }
    }

    params.set('summary','1');

    let options = new RequestOptions({search: params});

    return this.http.get(this.jobFreelancerUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public getOffersFreelancerById(id:string): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();


    params.append('id', id);

    let options = new RequestOptions({search: params});

    return this.http.get(this.jobFreelancerUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public postOffersAddFreelancer(id) {
    let params: URLSearchParams = new URLSearchParams();
    const body = {'job_id': id};

    let options = new RequestOptions({search: params});

    return this.http.post(this.jobAddFreelancerUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postJobCompanyPost(addCompany) {
    let params: URLSearchParams = new URLSearchParams();
    const body = addCompany;

    let options = new RequestOptions({search: params});

    return this.http.post(this.posCompanyUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postQuestionJob(job_id, question) {
    let params: URLSearchParams = new URLSearchParams();
    const body = {'job_id': job_id, 'question': question};

    let options = new RequestOptions({search: params});

    return this.http.post(this.qaUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersById(jobId: string): Observable<JobsOffer> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', jobId);
    const options = new RequestOptions({search: params});

    return this.http.get(this.jobUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersContractById(jobId: string): Observable<JobsOffer> {
    const params: URLSearchParams = new URLSearchParams();

    params.append('id', jobId);
    const options = new RequestOptions({search: params});

    return this.http.get(this.jobContractUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersLevelProfileUrl(jobId: string): Observable<JobsOffer> {
    let params: URLSearchParams = new URLSearchParams();

    params.append('id', jobId);
    let options = new RequestOptions({search: params});

    return this.http.get(this.levelProfileUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postOffers(jobOffer: JobsOffer): Observable<JobsOffer[]> {
    let params: URLSearchParams = new URLSearchParams();
    const body = jobOffer;

    let options = new RequestOptions({search: params});

    return this.http.post(this.jobUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putOffersStatus(id, status): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {id:id,status:status};

    let options = new RequestOptions({search: params});

    return this.http.put(this.jobStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putOffersQuantity(id, quantity): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {id:id,quantity:quantity};

    let options = new RequestOptions({search: params});

    return this.http.put(this.jobStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantById(id, mandatoryrequirementsmet): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('id', id);
    params.append('mandatoryrequirementsmet', mandatoryrequirementsmet);

    let options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantByOffer(id, status = 300): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('id', id);
    params.append('status', String(status));
    params.append('summary', '1');
    params.append('pagecount', '100');
    params.append('mandatoryrequirementsmet', '1');


    let options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getOffersApplicantByOfferReport(id, competence, status = 300): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.append('id', id);
    params.append('status', String(status));
    params.append('competence', String(competence));
    params.append('summary', '1');
    params.append('pagecount', '100');


    let options = new RequestOptions({search: params});

    return this.http.get(this.applicantUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/job-offers.service.ts